import { render, staticRenderFns } from "./PlanConsumption.vue?vue&type=template&id=3b9f2024&scoped=true&lang=pug"
import script from "./PlanConsumption.vue?vue&type=script&lang=js"
export * from "./PlanConsumption.vue?vue&type=script&lang=js"
import style0 from "./PlanConsumption.vue?vue&type=style&index=0&id=3b9f2024&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f2024",
  null
  
)

export default component.exports